<template>
  <t-layout>
    <t-aside>
      <Header></Header>
    </t-aside>
    <t-layout>
      <t-content style="min-height: 100vh;">
        <div style="padding:20px;">
          <div class="flex space-between">
            <div><span class="c-main fs-26 fw-600">在线留言</span></div>
          </div>
          <div class="mt-20">
            <t-table
                row-key="index"
                :data="listData"
                :columns="columns"
                :stripe="stripe"
                :bordered="bordered"
                :hover="hover"
                :table-layout="tableLayout ? 'auto' : 'fixed'"
                :size="size"
                :pagination="pagination"
                :show-header="showHeader"
                cell-empty-content="-"
                resizable
                lazy-load
                @page-change="onPageChange"
            >
              <template #op="row">
                <t-space>
                  <t-link theme="danger" @click="deleteProduct(row)">删除</t-link>
                </t-space>
              </template>

            </t-table>
          </div>
        </div>
      </t-content>
    </t-layout>
  </t-layout>

  <t-dialog v-model:visible="viewVisible" width="70vw" :closeBtn="false" cancelBtn="关闭" :confirmBtn="null">
    <t-row :gutter="16" style="overflow: hidden;">
      <t-col :span="4">
        <img :src="domainUrl+viewData.product_img" alt="" style="width:100%;">
      </t-col>

      <t-col :span="8">
        <div><span class="fs-26 fw-600">{{viewData.name}}</span>({{viewData.cat_name}})</div>
        <div class="mt-20 c-content">{{viewData.product_desc}}</div>
        <div class="mt-20 c-content">{{viewData.use_comment}}</div>
        <div class="mt-20">
          <div class="fs-18 fw-600">产品规格</div>
          <div class="mt-10 c-content">
            <div v-for="item in viewData.specifications" class="mt-10">
              <span style="width:140px;display:inline-block;text-align: left;">{{item.label}}:</span>
              <span class="ml-10">{{item.value}}</span>
            </div>
          </div>
        </div>
        <div class="mt-20">
          <div class="fs-18 fw-600">性能及质量标准</div>
          <div class="mt-10 c-content">
            <div v-for="item in viewData.quality_standard" class="mt-10">
              <span style="width:140px;display:inline-block;text-align: left;">{{item.label}}:</span>
              <span class="ml-10">{{item.value}}</span>
            </div>
          </div>
        </div>
      </t-col>
    </t-row>
  </t-dialog>

  <t-dialog v-model:visible="deleteVisible" :onConfirm="deleteAction">
    <p>确定要删除吗?</p>
  </t-dialog>
</template>

<script setup>
import Header  from '@/components/header.vue'
import {messageDeleteApi, messageListApi} from "@/api/message"

import {onMounted, ref} from 'vue';
import {MessagePlugin} from "tdesign-vue-next";
// const domainUrl = ref("http://localhost:8082")
const domainUrl = ref("https://www.hdcleanroom.com")
const listData = ref([]);
const pagination = ref({
  defaultCurrent: 1,
  defaultPageSize: 10,
  total:0,
});

const stripe = ref(true);
const bordered = ref(true);
const hover = ref(false);
const tableLayout = ref(false);
const size = ref('medium');
const showHeader = ref(true);

const deleteVisible = ref(false);
const deleteId = ref(0)

const columns = ref([
  {colKey: 'name', title: '姓名' },
  { colKey: 'email', title: '邮箱', },
  { colKey: 'phone', title: '联系方式', },
  { colKey: 'url', title: 'URL', },
  {colKey: 'remark', title: '留言'},
  {colKey: 'created_at', title: '留言时间'},
  {colKey: 'op', title: '操作'},
]);


onMounted(() => {
  messageList(1, 10)
})

const formatTime = (str) => {
  const d = new Date(str);
  const f = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${f(d.getMonth() + 1)}-${f(d.getDate())} `
      + `${f(d.getHours())}:${f(d.getMinutes())}:${f(d.getSeconds())}`;
};
const messageList = (currentPage, pageSize) => {
  messageListApi({page:currentPage,page_size:pageSize}).then(res => {
    if (res.data.code == 200) {
      listData.value = [];
      let data = res.data.data
      pagination.value.total = data.total_data.total;
      for (let i=0; i<data.list.length; i++) {
        listData.value.push({
          index: i + 1,
          name: data.list[i].name,
          id: data.list[i].id,
          email: data.list[i].email,
          phone: data.list[i].phone,
          url: data.list[i].url,
          remark: data.list[i].remark,
          created_at: formatTime(data.list[i].created_at)
        });
      }
    }
  })
}

const onPageChange = (pageInfo, context) => {
  let currentPage = pageInfo.current;
  let pageSize = pageInfo.pageSize;
  messageList(currentPage, pageSize)
}

const viewData = ref({})
const viewAct = (item) => {
  viewVisible.value = true;

  viewData.value = item;
}

const deleteProduct = (item) => {
  deleteVisible.value = true
  deleteId.value = parseInt(item.row.id)
}
const deleteAction = () => {
  messageDeleteApi({id:deleteId.value}).then(res => {
    if (res.data.code == 200) {
      MessagePlugin.success("操作成功！");
      deleteVisible.value = false
      deleteId.value = 0
      location.reload();
    }
  })
}



const viewVisible = ref(false)


</script>

<style scoped>

</style>
<style>
.t-dialog__body {
  overflow: hidden;
}
</style>